import { useState, useEffect } from 'react';

import {
    IconButton
} from '@mui/material';
import _ from 'lodash';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import { height } from '@mui/system';

const ImageListPreview = ({ images, handleDeleteImage, isDisabled }) => {
    return (
        <div className='image-preview-wrapper'>
            {images.length ? images.map((image, i) => 
                <ImagePreview isDisabled={isDisabled} key={i} image={image} handleDeleteImage={handleDeleteImage} /> ) : '' }
        </div>
    )
}

const ImagePreview = ({ image, handleDeleteImage, isDisabled}) => {
    const [displayCancel, setDisplayCancel] = useState(false);

    return (
        <div className='img-wrapper' 
            onMouseEnter={e => {
                setDisplayCancel(true);
            }}
            onMouseLeave={e => {
                setDisplayCancel(false);
            }}
        >
            <div className='img-container'>
                <img src={typeof image == 'string' ? image : image?.blob} />
                {displayCancel && 
                    <IconButton 
                        aria-label="delete" 
                        size="small" 
                        disabled={isDisabled}
                        onClick={() => handleDeleteImage(image)}
                        className='cancel-btn'>
                        <CancelIcon fontSize="inherit" color="error" />
                    </IconButton> 
                }
            </div>
            <span className='preview-text'>
                {displayCancel ? _.truncate(image && image?.fileName, { length: 15 }) : <span className='span-hidden'>Hideen</span> }
            </span>
        </div>  
    )
}

// const ImageUploader = ({ 
//     imageList = [],
//     setImageList,
//     multiple = false,
//     id = 'img',
//     name = 'img',
//     isDisabled=false,
//     message,
//     replaceImage,
//     getimage
// }) => {
//     const [previewImageList, setPreviewImageList] = useState([]);
//     const [initialLoad, setInitialLoad] = useState(true);

//     const setURL = (files) => {
//         for (let index in files) {
//             let file = files[index]

//             if (typeof file == 'object') {
//                 let reader = new FileReader();
//                 reader.readAsDataURL(file);
                
//                 setImageList(imageList => [...imageList, file])

//                 reader.onload = (e) => {
//                     let fileObj = {}
//                     fileObj['fileName'] = file?.name
//                     fileObj['key'] = previewImageList.length + +index + 1
//                     fileObj['blob'] = reader.result
//                     setPreviewImageList(images => [...images, fileObj]);
//                 };
//             }
//         }
//     };

//     useEffect(() => {
//         if (initialLoad && !_.isEmpty(getimage?imageList[0]:imageList)) {
//             setPreviewImageList(_.map(getimage?imageList[0]:imageList, i => {
//                 if (typeof i == 'object') return i.image
//                 else return i
//             }))
//             setInitialLoad(false);
//         }
//     }, [imageList])

//     const handleDeleteImage = (image) => {
//         if (!multiple) {
//             setImageList([])
//             setPreviewImageList([])
//             return;
//         }
//         console.log("image",image)
//         if(image?.fileName){
//             console.log("image",previewImageList,imageList,image)
//             setPreviewImageList(_.filter(previewImageList, i => i != image))
//             setImageList(_.filter(imageList[0], i => i != image))
//         }
//         if(typeof image === 'string'){
//             console.log("image",previewImageList,imageList,image)
//             setPreviewImageList(_.filter(previewImageList, i => i != image))
//             if (name == "product_img") {

//                 setImageList(_.filter(imageList, i => i.image != image))
//             } else {

//                 setImageList(_.filter(imageList[0], i => i != image))
//             }
//         }
//     }
// // This useEffect listens to the `replaceImage` function and triggers file input
// useEffect(() => {
//     if (replaceImage) {
//         replaceImage(() => {
//             document.getElementById(id).click();
//         });
//     }
// }, [replaceImage, id]);
//     return (
//         <div className="image-uploader-wrapper">
//             <div className='uploader-wrapper'>
//                 <div className='image-list-wrapper'>
//                     {!previewImageList.length ? <div className='input-wrapper'>
//                         <AddCircleIcon onClick={() => {
//                             document.getElementById(id).click();
//                         }} />
//                         <span className='uploader-text'>Drop a JPG/PNG image to upload or browse</span>
//                         <span className='uploader-sec-text'>{message ?`( ${message} )`: `(minimum 300 x 300 pixels)`}</span>
//                     </div> : ''}
//                     {previewImageList.length ? 
//                         <div className='preview-wrapper'>
//                             <ImageListPreview 
//                                 images={previewImageList} 
//                                 isDisabled={isDisabled}
//                                 handleDeleteImage={handleDeleteImage} />
//                             { multiple ?
//                             <div className='add-btn-wrapper'>
//                                 <AddCircleIcon onClick={() => {
//                                     document.getElementById(id).click();
//                                 }} />
//                             </div> : '' }
//                         </div>
//                     : ''}
//                 </div>
//             </div>
//             <div className='image-wrapper'>
//                 <input 
//                     type="file" 
//                     multiple={multiple}
//                     onChange={(event) => {
//                         setInitialLoad(false)
//                         setURL(event.target.files)
//                         event.target.value = ''
//                     }}
//                     id={id} 
//                     name={name} 
//                     hidden 
//                     accept="image/*" />
//             </div>
//         </div>
//     )
// }


const ImageUploader = ({ 
    imageList = [],
    setImageList,
    multiple = false,
    id = 'img',
    name = 'img',
    isDisabled = false,
    message,
    replaceImage,
    getimage
}) => {
    const [previewImageList, setPreviewImageList] = useState([]);
    const [initialLoad, setInitialLoad] = useState(true);

    const setURL = (files) => {
        for (let index in files) {
            let file = files[index];
            if (typeof file === 'object') {
                let reader = new FileReader();
                reader.readAsDataURL(file);

                setImageList(prev => [...prev, file]);

                reader.onload = (e) => {
                    let fileObj = {
                        fileName: file?.name,
                        key: previewImageList.length + +index + 1,
                        blob: reader.result,
                    };
                    setPreviewImageList(prev => [...prev, fileObj]);
                };
            }
        }
    };

    useEffect(() => {
        if (initialLoad && !_.isEmpty(getimage ? imageList[0] : imageList)) {
            setPreviewImageList(
                _.map(getimage ? imageList[0] : imageList, (i) =>
                    typeof i === 'object' ? i.image : i
                )
            );
            setInitialLoad(false);
        }
    }, [imageList]);

    const handleDeleteImage = (image) => {
        if (!multiple) {
            setImageList([]);
            setPreviewImageList([]);
            return;
        }

        if (image?.fileName) {
            setPreviewImageList(prev => _.filter(prev, i => i !== image));
            setImageList(prev => _.filter(imageList[0], i => i !== image));
        }

        if (typeof image === 'string') {
            setPreviewImageList(prev => _.filter(prev, i => i !== image));
            if (name === "product_img") {
                setImageList(prev => _.filter(prev, i => i.image !== image));
            } else {
                setImageList(prev => _.filter(imageList[0], i => i !== image));
            }
        }
    };

    useEffect(() => {
        if (replaceImage) {
            replaceImage(() => {
                document.getElementById(id).click();
            });
        }
    }, [replaceImage, id]);

    return (
        <div className="image-uploader-wrapper">
            <div className="uploader-wrapper">
                <div className="image-list-wrapper">
                    {!previewImageList.length && (
                        <div className="input-wrapper">
                            <AddCircleIcon onClick={() => document.getElementById(id).click()} />
                            <span className="uploader-text">
                                Drop a JPG/PNG image to upload or browse
                            </span>
                            <span className="uploader-sec-text">
                                {message ? `( ${message} )` : `(minimum 300 x 300 pixels)`}
                            </span>
                        </div>
                    )}

                    {previewImageList.length > 0 && (
                        <div
                            // className="preview-wrapper"
                            style={{
                                display: 'flex',
                                gap: '12px',
                                overflowX: 'auto',
                                whiteSpace: 'nowrap',
                                paddingBottom: '8px',
                            }}
                        >
                            {previewImageList.map((img, index) => (
                                <div
                                    key={index}
                                    style={{
                                        position: 'relative',
                                        width: '120px',
                                        height: '120px',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                    }}
                                >
                                    <img
                                        src={typeof img === 'string' ? img : img.blob}
                                        alt={`preview-${index}`}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                        }}
                                    />
                                    {!isDisabled && (
                                        <div
                                            onClick={() => handleDeleteImage(img)}
                                            style={{
                                                position: 'absolute',
                                                top: '6px',
                                                right: '6px',
                                                background: '#fff',
                                                color: '#000',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                boxShadow: '0 0 4px rgba(0,0,0,0.3)',
                                            }}
                                        >
                                            ×
                                        </div>
                                    )}
                                </div>
                            ))}

                            {multiple && (
                                <div
                                    className="add-btn-wrapper"
                                    style={{
                                        width: '120px',
                                        height: '120px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        border: '2px dashed #ccc',
                                        borderRadius: '8px',
                                        flexShrink: 0,
                                    }}
                                    onClick={() => document.getElementById(id).click()}
                                >
                                    <AddCircleIcon />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="image-wrapper">
                <input
                    type="file"
                    multiple={multiple}
                    onChange={(event) => {
                        setInitialLoad(false);
                        setURL(event.target.files);
                        event.target.value = '';
                    }}
                    id={id}
                    name={name}
                    hidden
                    accept="image/*"
                />
            </div>
        </div>
    );
};

export default ImageUploader;



export const ImageUploader1 = ({ 
    message,
    imageList = [],
    setImageList,
    setBannnerSize,
    multiple = false,
    id = 'img',
    name = 'img',
    label='',
    isDisabled = false,
    replaceImage,
    isSetUrl=false // New prop to trigger the image replacement
}) => {
    const [previewImageList, setPreviewImageList] = useState([]);
    const [initialLoad, setInitialLoad] = useState(true);
    
    
    const setURL = (files) => {
        if (!multiple) {
            // Clear existing image if not allowing multiple uploads
            setImageList([]);
            setPreviewImageList([]);
        }
        
        console.log("imageost",imageList)
        for (let index in files) {
            let file = files[index];

            if (typeof file === 'object') {
                const objectURL = URL.createObjectURL(file);

                // Create an image element to load the raw image
                let img = new Image();

                // Set the src of the image element to the object URL
                img.src = objectURL;
                img.onload = () => {
                    if(label === 'custombanner'){
                        setBannnerSize({
                            width: img.width, height: img.height })
                        console.log('Raw image width:', img.width, 'and height:', img.height);
                    }
                }
                let reader = new FileReader();
                reader.readAsDataURL(file);
                
                setImageList(imageList => [...imageList, file]);
                
                reader.onload = () => {
                    let fileObj = {
                        fileName: file?.name,
                        key: previewImageList.length + +index + 1,
                        blob: reader.result
                    };
                    setPreviewImageList(images => [...images, fileObj]);
                };
            }
        }
    };


    useEffect(() => {
        if(isSetUrl===true){
            setURL(imageList)
        }
    }, [isSetUrl])

    useEffect(() => {
    
       

        if (initialLoad && imageList.length > 0) {
            setPreviewImageList(imageList.map(i => {
                return typeof i === 'object' ? i.image : i;
            }));
            setInitialLoad(false);
        }
    }, [imageList, initialLoad]);

    const handleDeleteImage = (image) => {
        setImageList([]);
        setPreviewImageList([]);
    };

    // This useEffect listens to the `replaceImage` function and triggers file input
    useEffect(() => {
        if (replaceImage) {
            replaceImage(() => {
                document.getElementById(id).click();
            });
        }
    }, [replaceImage, id]);

    return (
        <div className="image-uploader-wrapper">
            <div className='uploader-wrapper'>
                <div className='image-list-wrapper'>
                    {!previewImageList.length ? 
                        <div className='input-wrapper'>
                            <AddCircleIcon onClick={() => {
                                document.getElementById(id).click();
                            }} />
                            <span className='uploader-text'>Drop a JPG/PNG image to upload or browse</span>
                            <span className='uploader-sec-text'>{message?`( ${message} )`: `(minimum 300 x 300 pixels)`}</span>
                        </div> 
                    : ''}

                    {/* {previewImageList.length ? 
                        <div className='preview-wrapper'>
                            <ImageListPreview 
                                images={previewImageList} 
                                isDisabled={isDisabled}
                                handleDeleteImage={handleDeleteImage} />
                        </div>
                    : ''} */}
                    {previewImageList.length ?
                        <div className='preview-wrapper' style={{ paddingTop: '12px', paddingBottom: '12px' }}>
                            <ImageListPreview
                                images={previewImageList}
                                isDisabled={isDisabled}
                                handleDeleteImage={handleDeleteImage} />
                            {/* <div className='add-btn-wrapper'>
                                <button onClick={() => document.getElementById(id).click()}>
                                    Select New Image
                                </button>
                            </div> */}
                        </div>
                    : ''}
                </div>
            </div>
            <div className='image-wrapper'>
                <input 
                    type="file" 
                    multiple={multiple}
                    onChange={(event) => {
                        setInitialLoad(false);
                        setURL(event.target.files);
                        event.target.value = '';
                    }}
                    id={id} 
                    name={name} 
                    hidden 
                    accept="image/*" 
                />
            </div>
        </div>
    );
};

